import React, { useState } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { columnProps } from '../../Services/Functions'
import { Button } from '../../Components/Common/Button'
import { useNavigate } from 'react-router-dom'
import { useCQuery } from '../../Services/QueryCache'
import { Text } from '../../Components/Common/Text'
import { deleteEnvironment } from './Functions'
import { Modal } from '../../Components/Common/Modal'

export const EnvironmentsList = () => {
  const { data: environments = [] } = useCQuery(['environments'])
  const [modalVisible, setModalVisible] = useState(false)
  const [idToDelete, setIdToDelete] = useState('')

  const navigate = useNavigate()

  const BtnActionProc = ({ id }) => (
    <Flex row style={{ width: '100%' }}>
      <Button round tooltip='Visualizza' icon='fa-duotone fa-pen' style={{ marginRight: 10 }} onClick={() => navigate('/environments/' + id)} />
      <Modal visible={modalVisible} header='Cancellazione environment' onHide={() => setModalVisible(false)}>
        <Flex fw>
          <Text value='Vuoi cancellare questa environment?' />
          <Flex fw row jb style={{ marginTop: 20 }}>
            <Button label='Annulla' icon='fa-duotone fa-trash' onClick={() => setModalVisible(false)} />
            <Button
              label='Conferma' icon='fa-duotone fa-check' onClick={() => {
                deleteEnvironment(idToDelete)
                setModalVisible(false)
              }}
            />
          </Flex>
        </Flex>
      </Modal>
      <Button round tooltip='Elimina' icon='fa-duotone fa-trash' onClick={() => { setIdToDelete(id); setModalVisible(true) }} />
      <Button round tooltip='Form PDF' icon='fa-duotone fa-file-pdf' onClick={() => navigate('/environments/' + id + '/mapDocument/list')} style={{ marginLeft: 10 }} />
      <Button round tooltip='Form Web' icon='fa-duotone fa-globe-pointer' onClick={() => navigate('/environments/' + id + '/webForm/list')} style={{ marginLeft: 10 }} />
      <Button round tooltip='Statistiche' icon='fa-duotone fa-square-poll-vertical' onClick={() => navigate('/environments/' + id + '/forms')} style={{ marginLeft: 10 }} />
    </Flex>
  )

  return (
    <Flex fw>
      <Flex fw jb row>
        <div style={{ width: '20%' }} />
        <Text value='Elenco Environment' size={22} bold />
        <Flex ae style={{ width: '20%' }}>
          <Button label='Aggiungi' icon='fa-duotone fa-plus' onClick={() => navigate('/environments/new')} />
        </Flex>
      </Flex>
      <DataTable
        style={{ width: '100%', marginTop: 20 }} filterDisplay='row' className='TableSignatures' sortField='createdAt' sortOrder={-1}
        value={environments} emptyMessage='Nessuna environment presente' responsiveLayout='scroll' paginator rows={10}
      >
        <Column field='name' {...columnProps('Nome')} />
        <Column field='codSociety' {...columnProps('Codice Società')} />
        <Column field='tomcatCode' {...columnProps('Tomcat')} />
        <Column style={{ border: 'none', width: 220, height: 15, textAlign: 'center' }} body={(props) => <BtnActionProc {...props} />} />
      </DataTable>
    </Flex>
  )
}
